import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import { otpVerification, resendOtp } from "../../services/auth.services";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import Swal from "sweetalert2";
import { globalLoader, handleServerValidations } from "../../../../utils/commonfunction";
import OtpInput from "react-otp-input";
import backLogo from "../../../../assets/business/images/Button-icon.svg";
import logo from "../../../../assets/Discount_App_logo.png";
import loginImage from "../../../../assets/business/images/login-page-img.png";
import * as Yup from "yup";

function BusinessVerifyOTP() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [otp, setOtp] = useState("");
  const [resendDisabled, setResendDisabled] = useState(false);
  const [counter, setCounter] = useState(0);

  const validationSchema = Yup.object().shape({
    otp: Yup.string().length(6, "OTP must be 6 digits").required("OTP is required"),
  });

  const formik = useFormik({
    initialValues: { otp: "" },
    validationSchema: validationSchema,

    onSubmit: (values, { resetForm }) => {
      globalLoader(true);
      const formData = new FormData();
      formData.append("otp", values.otp);
      formData.append("type", "password_reset");

      const input = location?.state?.email?.trim() || "";
      const type = location?.state?.type_data;

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^\+?(\d{1,4})[\s]?(\d{6,14})$/;

      if (type === "email" && emailRegex.test(input)) {
        formData.append("email", input.toLowerCase());
      } else if (type === "phone_number" && phoneRegex.test(input)) {
        const match = input.match(phoneRegex);
        const countryCode = `+${match[1]}`;
        const phone = match[2];
        const fullNumber = `${countryCode} ${phone}`;
        const phone_number = {
          countryCode,
          phone,
          fullNumber,
        };
        formData.append("phone_number", JSON.stringify(phone_number));
      }
      otpVerification(formData)
        .then((response) => {
          globalLoader(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            navigate("/business/reset-password", {
              state: {
                validate_string: response?.data?.validate_string,
              },
            });
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          globalLoader(false);
          console.log("OTP verification error:", error);
        });
    },
  });

  useEffect(() => {
    if (resendDisabled) {
      const timer = setInterval(() => {
        setCounter((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [resendDisabled]);

  const handleResend = () => {
    setOtp("");
    setCounter(60);
    setResendDisabled(true);
    const formData = new FormData();
    const input = location?.state?.email?.trim() || "";
    const type = location?.state?.type_data;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^\+?(\d{1,4})[\s]?(\d{6,14})$/;

    if (type === "email" && emailRegex.test(input)) {
      formData.append("email", input.toLowerCase());
    } else if (type === "phone_number" && phoneRegex.test(input)) {
      const match = input.match(phoneRegex);
      const countryCode = `+${match[1]}`;
      const phone = match[2];
      const fullNumber = `${countryCode} ${phone}`;
      const phone_number = {
        countryCode,
        phone,
        fullNumber,
      };
      formData.append("phone_number", JSON.stringify(phone_number));
    }
    formData.append("type", "reset_password");
    resendOtp(formData)
      .then((response) => {
        if (response.success) {
          Swal.fire({
            icon: "success",
            text: response.message,
            ...SWAL_SETTINGS,
          });
        } else {
          Swal.fire({
            icon: "error",
            text: response.message,
            ...SWAL_SETTINGS,
          });
        }
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  return (
    <section className="welcome-screen">
      <div className="row m-0 align-items-center vh-100">
        <div className="col-md-6 p-0">
          <div className="welcome-screen-box login-box">
            <div className="welcome-screen-box-in py-4">
              <div className="back-button">
                <Link to="{`/business/forget-password`}" className="d-flex align-items-center gap-2">
                  <i className="fi-rr-arrow-small-left"></i> <span>Back</span>
                </Link>
              </div>
              <div className="logo mb-4 text-center">
                <Link to="#">
                  <img src={logo} alt="logo" />
                </Link>
              </div>
              <div className="heading-text-auth mb-3">
                <h3 className="h3-headline text-center">Verify Your Account</h3>
                <p className="body-2 text-center mt-2">Enter the 6-digit code we sent.</p>
              </div>

              <form className="mt-2 w-100 d-flex flex-column align-items-center" onSubmit={formik.handleSubmit}>
                <OtpInput
                  value={otp}
                  onChange={(value) => {
                    setOtp(value);
                    formik.setFieldValue("otp", value);
                  }}
                  numInputs={6}
                  isInputNum
                  shouldAutoFocus
                  containerStyle="otp-phone mt-3 d-flex justify-content-center"
                  inputStyle="vartical form-control text-center"
                  renderInput={(props, index) => (
                    <input
                      {...props}
                      key={index}
                      className="vartical form-control text-center"
                      onKeyDown={(e) => {
                        const allowedKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"];
                        if (e.ctrlKey || e.metaKey) return; // allow Ctrl/Cmd combos like paste
                        if (!allowedKeys.includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      maxLength="1"
                      style={{
                        width: "55px",
                        height: "50px",
                        margin: "0 5px",
                        fontSize: "20px",
                        fontWeight: "600",
                      }}
                    />
                  )}
                />

                {formik.errors.otp && formik.touched.otp && <div className="text-danger mt-2">{formik.errors.otp}</div>}

                <div className="get-started-btn mt-4 d-flex flex-column gap-3">
                  <button type="submit" className="btn btn-oring px-5">
                    Continue
                  </button>
                </div>
              </form>

              <div className="body-2 form-last-text mt-4 text-center" htmlFor="agreeCheck">
                Didn’t get a code?
                {resendDisabled ? (
                  <a href="#" className="subtitle-2  ms-2">
                    Resend in {counter}s
                  </a>
                ) : (
                  <a
                    href="#"
                    className="subtitle-2 ms-2"
                    onClick={(e) => {
                      e.preventDefault();
                      handleResend();
                    }}>
                    Resend OTP
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 p-0">
          <div className="hero-img">
            <img src={loginImage} className="" alt="Login visual" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default BusinessVerifyOTP;
